import { render, staticRenderFns } from "./UserDetailsAdministrationLockUserForm.vue?vue&type=template&id=48842c14&"
import script from "./UserDetailsAdministrationLockUserForm.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAdministrationLockUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports